var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.copied)?_c('v-icon',{staticClass:"copy-icon",on:{"click":_vm.handleClick}},[_vm._v("mdi-content-copy")]):_c('v-icon',[_vm._v("mdi-check")])
}
var staticRenderFns = []

export { render, staticRenderFns }